import { Body } from "@leafygreen-ui/typography";
import { StyledRouterLink, WordBreak } from "@evg-ui/lib/components/styles";
import { getTaskRoute } from "constants/routes";
import { formatZeroIndexForDisplay } from "utils/numbers";

interface TaskLinkProps {
  execution?: number;
  onClick?: () => void;
  showTaskExecutionLabel?: boolean;
  taskId: string;
  taskName: string;
}

export const TaskLink: React.FC<TaskLinkProps> = ({
  execution,
  onClick,
  showTaskExecutionLabel,
  taskId,
  taskName,
}) => (
  <StyledRouterLink onClick={onClick} to={getTaskRoute(taskId, { execution })}>
    <WordBreak all>{taskName}</WordBreak>
    {showTaskExecutionLabel && (
      // @ts-expect-error: FIXME. This comment was added by an automated script.
      <Body>Execution {formatZeroIndexForDisplay(execution)}</Body>
    )}
  </StyledRouterLink>
);
